

export class Converted {
    id: number;
    name: string;
}

export class Analyzed {
    id: number;
    name: string;
}

export class Payment {
    id: number;
    name: string;
}

export class Media {
    id: number;
    filename: string;
    path: string;
    converted: Converted;
    analyzed: Analyzed;
    cat?: any;
    keep: boolean;
    metadata?: any;
    private: boolean;
    community: boolean;
    userId: string;
    createdDate: Date;
    modifiedDate: Date;
    fileSize: number;
    payment: Payment;
    selected: boolean;
    featured: boolean;
    recommended: boolean;
    description: string;
}

export class MediaWithCost {
    cost: number;
    media: Media;
}

export class MediaWithTotalCost {
    totalCost: number;
    mediaList: MediaWithCost[];
}

